import styled from 'styled-components'

export const StyledSidebarItem = styled.a`
    border-bottom: ${({ theme }) => `${theme.typography.border.width.xxxThin} solid ${theme.colors.tfwBlack12}`};
    padding: 1.25rem;
    display: ${({ theme }) => theme.style.display.block};
    text-align: ${({ theme }) => theme.style.textAlign.right};
    text-decoration: none;
    font-family: ${({ theme }) => theme.typography.font.family.lato};
    font-size: ${({ theme }) => theme.typography.font.size.medium};
    font-weight: 300;
    color: inherit;
`
